const layersSourceFilenames = {
    GNA: {
        punti: "MOSI_multipoint_pt.fgb",
        linee: "MOSI_multilinea_ln.fgb",
        poligoni: "MOSI_multipolygon_pt.fgb", //NOT TO USE
        poligoni2: "MOSI_multipolygon_pl.fgb",
        progetti: "MOPR_pl.fgb",
        ricostruitiLinee: "R_MOSI_multilinea_ln.fgb",
        ricostruitiPoligoni: "R_MOSI_multipolygon_pl.fgb",
    },
    AltreBancheDati: {
        censimento: "Censimento_pt.fgb",
        tess: "tess_pt.fgb",
    },
    Concessione: "concessioni_pt.fgb",
    ICCD: "Catalogo_pt.fgb",
};

export { layersSourceFilenames };

//temporary
const layerSourceArray = [
    "Censimento_pt.fgb", //Data "Altre banche dati" (censimento)
    "tess_pt.fgb", //Data "Altre banche dati" (tess)
    "concessioni_pt.fgb", //Data "Indagini in concessione"
    "Catalogo_pt.fgb", //Data "ICCD"
    //Data GNA
    "MOSI_multipoint_pt.fgb", //Siti (punti)
    "MOSI_multilinea_ln.fgb", //Siti (linee)
    "MOSI_multipolygon_pt.fgb", //Siti (poligoni)
    "MOSI_multipolygon_pl.fgb", //Siti (poligoni)
    "MOPR_pl.fgb", //Progetti
    "R_MOSI_multipolygon_pl.fgb", //Siti ricostruiti (poligoni)
    "R_MOSI_multilinea_ln.fgb", //Siti ricostruiti (linee)
];
